import ConfigurationService from '@src/service/ConfigurationService'
import { convertUnit } from '@src/service/coins/coins'

import { UserProp } from '@src/stores/auth/user'
import { getUserPreference } from '@src/stores/auth/preferences'
import { getAuthState } from '@src/stores/auth'

export const isUserLoggedIn = () =>  {
  const state = getAuthState()
  if (state.type !== 'LoggedIn') return false;
  if (state.data.user.anonymousHash) return false;
  return true;
}

export const roundNumberToLength = (value: number, requiredNumberOfSybols: number = 5) => {
  const numerOfSymbols = value.toString().split('.')[0].length
  const numerOfSymbolsLeft = numerOfSymbols >= requiredNumberOfSybols ? 0 : requiredNumberOfSybols - numerOfSymbols
  const res = Math.round(value * 10 ** numerOfSymbolsLeft) / 10 ** numerOfSymbolsLeft
  return res.toLocaleString('en-US')
}

export const userHasRole = (...roles: string[]) => {
  const state = getAuthState()
  if (state.type !== 'LoggedIn') return false;

  const { user } = state.data;
  if (!user.roles) return false;

  // return true if the user has any of the specified roles
  return user.roles.some((role) => {
    return roles.includes(role);
  })
}

export const isAdminUser = () => userHasRole('admin')
export const isModeratorUser = () => userHasRole('admin', 'moderator')

export const convertToK = (num: number) => {
  if (num === 0) return '0'
  if (Math.abs(num) < 1000) return num.toString()

  const sign = Math.sign(num)
  const absNum = Math.abs(num)
  const kValue = absNum / 1000

  const formattedValue = kValue % 1 === 0 ? kValue.toFixed(0) : kValue.toFixed(1)

  return sign === -1 ? `-${formattedValue}K` : `${formattedValue}K`
}

export const formatNumberWithCommas = (num: number) => {
  const roundedNum = Math.round(num)

  return roundedNum.toLocaleString('en-US')
}

export const getGameURL = ({ gameId }) => {
  if (!gameId) return '#'

  switch (gameId) {
    case 'blackjack':
      return '/game/bitcoin-blackjack'
    case 'bjfun:plinko':
      return '/game/bjfun:plinko'
    case 'bjfun:limbo':
      return '/game/bjfun:limbo'
    case 'bjfun:mines':
      return '/game/bjfun:mines'
    case 'bjfun:crash':
      return '/game/bjfun:crash'
    case 'bjfun:dice':
      return '/game/bjfun:dice'
    case 'redorblack':
      return '/game/redorblack'
    default:
      return `/game/${gameId}`
  }
}

export const gameClickHandler = (gameId: string, provider: string, history: any) => {
  const gameURL = getGameURL({ gameId })
  history.push(gameURL)
}

export const formatAmount = (amount: number, currency: string) => {
  const c = ConfigurationService.instance.getCurrency(currency)
  const format = getUserPreference(('unit_' + c.short) as UserProp, (value) => value || c.format)

  return convertUnit(amount, c.m_unit, c.s_unit, format)
}

export const formatCurrency = (amount: number | null, defaultValue: string = '$0') => {
  if (!amount) return defaultValue
  return `$${formatNumberWithCommas(amount / 100)}`
}

export const formatDate = (dateString: string, defaultValue: string = '-') => {
  if (!dateString) return defaultValue
  return new Date(dateString).toLocaleDateString()
}

export const dec2hex = (dec: number) => {
  return ('0' + dec.toString(16)).substr(-2)
}

// generateId :: Integer -> String
export const generateRandomString = (length: number) => {
  const arr = new Uint8Array(length)
  const crypto = window.crypto || (window as any).msCrypto
  crypto.getRandomValues(arr)
  return Array.from(arr, dec2hex).join('')
}

export const getStrapiUrl = () => {
  return import.meta.env.VITE_STRAPI_URL || 'http://localhost:1337';
}